



































import { Component, Vue } from 'vue-property-decorator';
import AudienceSearchPanel from '@/components/AudienceSearchPanel.vue';
import AudienceSearchResults from '@/components/AudienceSearchResults.vue';
import AudienceSearchToggle from '@/components/AudienceSearchToggle.vue';
import { AudienceSearchFilter } from '../models/AudienceSearchFilter';
import { Mutation, Action, Getter } from 'vuex-class';
import * as $ from 'jquery';
import router from '../router';
import BaseView from '../BaseView';
const namespace: string = 'counter';

@Component({
    components: {
        AudienceSearchPanel,
        AudienceSearchResults,
        AudienceSearchToggle
    },
})
export default class ManageAudiences extends BaseView {

    @Getter('currentClientId', { namespace })
    private clientId!: number;

    @Getter('currentIsSelectable', { namespace })
    private isSelectable!: boolean;

    @Getter('currentSelectedAudienceID', { namespace })
    private selectedAudienceID!: number;

    @Getter('SearchToggleCache', { namespace: 'manageAudience' })
    private SearchToggleCache!: any;

    @Getter('SearchResultTableCache', { namespace: 'manageAudience' })
    private SearchResultTableCache!: any;

    private audienceSearchFilters: AudienceSearchFilter[] = [];

    private initialSearchToggleFilter: AudienceSearchFilter = new AudienceSearchFilter(
        'audienceDetailType',
        'equals',
        'LastPublished');

    private initialSearchPanelFilter: AudienceSearchFilter = new AudienceSearchFilter(
        'isActive',
        'equals',
        'true');

    private created() {
        if (this.SearchToggleCache != null) {
            this.initialSearchToggleFilter = this.SearchToggleCache;
        }
        this.audienceSearchFilters.push(
            this.initialSearchToggleFilter,
            this.initialSearchPanelFilter,
            new AudienceSearchFilter(
                'isActive',
                'equals',
                true)
        );
    }

    private mounted() {
        if (this.SearchResultTableCache) {
            this.updateSearchResults();
        }
    }

    private updateSearchResults(): void {
        const results: any = this.$refs.searchPanelRef;
        const otherRes: any = this.$refs.searchToggleRef;
        results.cacheSearchPanel();
        this.audienceSearchFilters = JSON.parse(
            JSON.stringify(results.SearchFilterResults as AudienceSearchFilter[])
        );

        const toggle = this.isSelectable ?
            {
                Field: 'audienceDetailType',
                Operator: 'equals',
                Value: 'LastPublished'
            }
            : otherRes.ToggleFilterResults[0];
        this.audienceSearchFilters.push(JSON.parse(JSON.stringify(toggle)));
    }

    private openAddAudienceFullScreenModal() {
        this.$router.push('/audience/create');
    }
}
